<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <small>{{ activeUserInfo.branchName }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block"/>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Perfil</span>
          </li>

<!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
<!--            <feather-icon icon="MailIcon" svgClasses="w-4 h-4"/>-->
<!--            <span class="ml-2">Bandeja de entrada</span>-->
<!--          </li>-->

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Mensajes</span>
          </li>

          <vs-divider class="m-1"/>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">Cerrar sesión</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js');
  export default {
    data() {
      return {}
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      config() {
        return deltaPOS_config.default;
      }
    },
    methods: {
      logout() {
        var userInfo = {
          uid: 0,
          userId: 0,
          login: '',
          userName: '',
          displayName: '',
          token: ''
        };
        localStorage.removeItem(`${this.config.itemPrefix}UserInfo`);
        localStorage.removeItem(`${this.config.itemPrefix}UserId`);
        localStorage.removeItem(`${this.config.itemPrefix}Login`);
        localStorage.removeItem(`${this.config.itemPrefix}UserName`);
        localStorage.removeItem(`${this.config.itemPrefix}Token`);
        this.$store.dispatch('updateUserInfo', userInfo);
        this.$router.push('/login').catch(() => {
        })
      },
    }
  }
</script>
